<app-login [hidden]="isLoggedIn"></app-login>
<app-private [hidden]="!isLoggedIn"></app-private>
